export const CalculateEvenly = (start: number, end: number, step: number): number[] => {
  const 
    median = start === end ? Math.max(start, end) : Math.floor(((end - start) * 50 / 100 + start)),
    diff = Math.ceil((Math.max(start, end) - Math.min(start, end)) / (step - 1)),
    diffList = [];
  for(let count = 1; count < Math.floor(step / 2); count++) {
    diffList.push(diff * count);
  }
  const startList = diffList.slice(0).reverse().map((diff) => {
    if(start < end) {
      return median < start ? median: median - diff < start ? start : median - diff;
    } else {
      return median < start ? median + diff < start ? median + diff : start : median;
    }
  })
  const endList = diffList.map((diff) => {
    if(start < end) {
      return median < end ? median + diff < end ? median + diff : end : median;
    } else {
      return median < end ? median : median - diff < end ? end : median - diff;
    }
  })
  return step % 2 === 0 ? [start, ...startList, ...endList, end] : [start, ...startList, median, ...endList, end]; 
}